import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from '../../axios/axiosconf';
import './SuperadminStyles.css';

const LoginSuperadmin = () => {
    const history = useHistory();
    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post('/superadmin/login', formData);

            if (response.status === 200) {
                // Guardar token y datos del superadmin
                localStorage.setItem('superadmin_token', response.data.token);
                localStorage.setItem('superadmin_user', JSON.stringify(response.data.user));

                // Redirigir al dashboard
                history.push('/superadmin/dashboard');
            }
        } catch (err) {
            setLoading(false);
            if (err.response) {
                setError(err.response.data.message || 'Error al iniciar sesión');
            } else {
                setError('Error de conexión. Intente nuevamente.');
            }
        }
    };

    return (
        <div className="superadmin-login-container">
            <div className="superadmin-login-card">
                <div className="superadmin-login-header">
                    <i className="fas fa-user-shield fa-3x mb-3"></i>
                    <h2>Panel de Superadministrador</h2>
                    <p className="text-muted">SmileWEB</p>
                </div>

                <form onSubmit={handleSubmit}>
                    {error && (
                        <div className="alert alert-danger" role="alert">
                            <i className="fas fa-exclamation-circle"></i> {error}
                        </div>
                    )}

                    <div className="form-group">
                        <label htmlFor="username">Usuario</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fas fa-user"></i>
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                id="username"
                                name="username"
                                value={formData.username}
                                onChange={handleChange}
                                required
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Contraseña</label>
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text">
                                    <i className="fas fa-lock"></i>
                                </span>
                            </div>
                            <input
                                type="password"
                                className="form-control"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="btn btn-dark btn-block"
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                Iniciando sesión...
                            </>
                        ) : (
                            <>
                                <i className="fas fa-sign-in-alt mr-2"></i>
                                Iniciar Sesión
                            </>
                        )}
                    </button>
                </form>

                <div className="superadmin-login-footer">
                    <small className="text-muted">
                        Acceso restringido solo para superadministradores
                    </small>
                </div>
            </div>
        </div>
    );
};

export default LoginSuperadmin;
